import { Currency, ETHER } from '@uniswap/sdk'
import { NATIVE_NAME, NATIVE_SYMBOL } from '../chainConfig'

export function currencySymbol(currency?: Currency | null): string | undefined {
  if (!currency) return undefined
  if (currency === ETHER) return NATIVE_SYMBOL
  return currency.symbol
}

export function currencyName(currency?: Currency | null): string | undefined {
  if (!currency) return undefined
  if (currency === ETHER) return NATIVE_NAME
  return currency.name
}
